import Axios from 'axios';
import { toastr } from 'react-redux-toastr';
import { createAction } from 'redux-act';
import { url } from 'utils/url';
import { errorMsg } from 'utils';
import dayjs from 'dayjs';

export const EVENTS_FETCH_DATA_INIT = createAction('EVENTS_FETCH_DATA_INIT');
export const EVENTS_FETCH_DATA_SUCCESS = createAction(
  'EVENTS_FETCH_DATA_SUCCESS'
);
export const EVENTS_FETCH_DATA_FAIL = createAction('EVENTS_FETCH_DATA_FAIL');

export const EVENTS_DELETE_EVENT_INIT = createAction(
  'EVENTS_DELETE_EVENT_INIT'
);
export const EVENTS_DELETE_EVENT_SUCCESS = createAction(
  'EVENTS_DELETE_EVENT_SUCCESS'
);
export const EVENTS_DELETE_EVENT_FAIL = createAction(
  'EVENTS_DELETE_EVENT_FAIL'
);

export const EVENTS_CLEAR_DATA = createAction('EVENTS_CLEAR_DATA');

export const EVENTS_CREATE_EVENT_INIT = createAction(
  'EVENTS_CREATE_EVENT_INIT'
);
export const EVENTS_CREATE_EVENT_SUCCESS = createAction(
  'EVENTS_CREATE_EVENT_SUCCESS'
);
export const EVENTS_CREATE_EVENT_FAIL = createAction(
  'EVENTS_CREATE_EVENT_FAIL'
);

export const EVENTS_MODIFY_EVENT_INIT = createAction(
  'EVENTS_MODIFY_EVENT_INIT'
);
export const EVENTS_MODIFY_EVENT_SUCCESS = createAction(
  'EVENTS_MODIFY_EVENT_SUCCESS'
);
export const EVENTS_MODIFY_EVENT_FAIL = createAction(
  'EVENTS_MODIFY_EVENT_FAIL'
);

export const EVENTS_CLEAN_UP = createAction('EVENTS_CLEAN_UP');

export const EVENTS_CLEAR_DATA_LOGOUT = createAction(
  'EVENTS_CLEAR_DATA_LOGOUT'
);
export const EVENTS_SYNC_EVENT_INIT = createAction('EVENTS_SYNC_EVENT_INIT');
export const EVENTS_SYNC_EVENT_SUCCESS = createAction(
  'EVENTS_SYNC_EVENT_SUCCESS'
);
export const EVENTS_SYNC_EVENT_FAIL = createAction('EVENTS_SYNC_EVENT_FAIL');

export const fetchEvents = ({
  siteId,
  type,
  // categoryId = 'all',
  // type = 'published',
}) => {
  // eslint-disable-next-line
  return async (dispatch, getState) => {
    dispatch(EVENTS_FETCH_DATA_INIT());

    if (siteId) {
      let events;
      try {
        events = await Axios.post(
          `${url}/event/filter`,
          {
            siteId,
            type,
          },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
            },
          }
        );
      } catch (error) {
        let errorMessage;
        if (error.response) {
          errorMessage = error && error.response && error.response.data.message;
        }
        toastr.error('', errorMessage);
        return dispatch(EVENTS_FETCH_DATA_FAIL({ error }));
      }
      events = events.data.data;
      return dispatch(
        EVENTS_FETCH_DATA_SUCCESS({
          list: events,
          event: getState().events.event,
        })
      );
    }
  };
};

export const syncEvent = () => {
  return async (dispatch) => {
    dispatch(EVENTS_SYNC_EVENT_INIT());
    Axios.get(`${url}/event/fetch`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
      },
      // responseType: 'blob',
      // params: {
      //   siteId,
      // },
    })
      .then(() => {
        return dispatch(EVENTS_SYNC_EVENT_SUCCESS());
      })
      .catch((error) => {
        toastr.error('', `${errorMsg(dispatch, error)}`);
        return dispatch(EVENTS_SYNC_EVENT_FAIL({ error }));
      });
  };
};

export const createEvent = (data) => {
  return async (dispatch) => {
    dispatch(EVENTS_CREATE_EVENT_INIT());

    const event = new FormData();
    event.set('siteId', data.siteId);
    event.set('title', data.title || data.Title);

    if (data.description || data.Description) {
      event.set('description', data.description || data.Description);
    }

    if (data.status) event.set('status', data.status);
    if (data.uri) event.set('uri', data.uri);
    if (data.locations) event.set('locations', data.locations);
    if (data.linkUrl) event.set('linkUrl', data.linkUrl);

    if (data.dateGmt || data.date) {
      event.set('dateGmt', dayjs(data.dateGmt || data.date).format());
    }
    if (data.time) event.set('time', data.time);

    // Handle poiIds from eventDetails
    if (data.eventDetails?.poiIds) {
      event.set('poiIds', JSON.stringify(data.eventDetails.poiIds));
    }

    // Handle ticketPrice
    if (data.eventDetails?.ticketPrice) {
      event.set('ticketPrice', data.eventDetails.ticketPrice);
    }

    // Handle file upload
    if (data.file) {
      event.append('file', data.file);
    }

    try {
      await Axios.post(`${url}/event/create`, event, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Please fill in all required fields';
      toastr.error('', errorMessage);
      return dispatch(
        EVENTS_CREATE_EVENT_FAIL({
          error: error?.response?.data,
        })
      );
    }
    toastr.success('', 'Event created successfully');
    return dispatch(EVENTS_CREATE_EVENT_SUCCESS({ event: data }));
  };
};

export const modifyEvent = (data) => {
  return async (dispatch) => {
    dispatch(EVENTS_MODIFY_EVENT_INIT());

    const event = new FormData();
    event.set('id', data.id || data._id);
    event.set('siteId', data.siteId);
    event.set('title', data.title || data.Title);

    if (data.description || data.Description) {
      event.set('description', data.description || data.Description);
    }

    if (data.status !== undefined) event.set('status', data.status);
    if (data.uri) event.set('uri', data.uri);
    if (data.locations) event.set('locations', data.locations);
    if (data.linkUrl) event.set('linkUrl', data.linkUrl);

    if (data.dateGmt || data.date) {
      event.set('dateGmt', dayjs(data.dateGmt || data.date).format());
    }
    if (data.time) event.set('time', data.time);

    // Handle poiIds from eventDetails
    if (data.eventDetails?.poiIds) {
      event.set('poiIds', JSON.stringify(data.eventDetails.poiIds));
    }

    // Handle ticketPrice
    if (data.eventDetails?.ticketPrice !== undefined) {
      event.set('ticketPrice', data.eventDetails.ticketPrice);
    }

    // Handle existing images (only if not empty)
    if (data.eventDetails?.images?.length > 0) {
      event.set('images', JSON.stringify(data.eventDetails.images));
    }

    // Handle new file upload
    if (data.file) {
      event.append('file', data.file);
    }

    try {
      await Axios.put(`${url}/event/edit`, event, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          'content-type': 'multipart/form-data',
        },
      });
    } catch (error) {
      const errorMessage = error?.response?.data?.message || 'Error updating event';
      toastr.error('', errorMessage);
      return dispatch(
        EVENTS_MODIFY_EVENT_FAIL({
          error: error?.response?.data,
        })
      );
    }
    toastr.success('', 'Event updated successfully');
    return dispatch(EVENTS_MODIFY_EVENT_SUCCESS({ event: data, id: data.id || data._id }));
  };
};

export const deleteEvent = ({ id, siteId }, cb) => {
  return async (dispatch) => {
    dispatch(EVENTS_DELETE_EVENT_INIT());
    try {
      await Axios.post(
        `${url}/event/delete`,
        {
          eventId: id,
          siteId,
        },
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem('accessToken')}`,
          },
        }
      );
    } catch (error) {
      let errorMessage;
      if (error.response) {
        errorMessage = error && error.response && error.response.data.message;
      }
      toastr.error('', errorMessage);
      return dispatch(
        EVENTS_DELETE_EVENT_FAIL({
          error: error && error.response && error.response.data,
        })
      );
    }

    toastr.success('', 'The event was deleted.');
    cb();
    return dispatch(EVENTS_DELETE_EVENT_SUCCESS({ id }));
  };
};

export const eventsCleanUp = () => (dispatch) => dispatch(EVENTS_CLEAN_UP());